

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class WalletEventsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-events';
        this.Server = this.props.context.getState().server.walletEvents;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['resourceId', 'event'];

        const defaultHead = [
            {
                id: 'resourceId',
                label: 'resourceId',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'event',
                label: 'event',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'payload',
                label: 'payload',
                alignRight: false,
                cell: 'Json',
                displayGrid: false,
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'response',
                label: 'response',
                alignRight: false,
                cell: 'Json',
                displayGrid: false,
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

